module.exports = __webpack_public_path__ + "img/service.19bf5f30.svg";